<template>
  <div class="transylvania">
    <h1>Transylvania / Siebenbürgen</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/deva_1kl.jpg" width="150" height="110" border="0" alt="Deva: Festung"
        @click="callImageClick('Deva: Festung', 'deva_1.jpg', $event)">
				<br>Deva: Festung
      </div>
      <div class="foto">
        <img src="../assets/fotos/tran_1kl.jpg" width="125" height="110" border="0" alt="Transilvania, Siebenbürgen: Großau, Christian"
        @click="callImageClick('Transilvania, Siebenbürgen: Großau, Christian', 'tran_1.jpg', $event)">
				<br>Transilvania, Siebenbürgen: Großau, Christian
      </div>
      <div class="foto">
				<img src="../assets/fotos/tran_2kl.jpg" width="125" border="0" height="110" alt="Transilvania, Siebenbürgen: Ortsdurchfahrt"
        @click="callImageClick('Transilvania, Siebenbürgen: Ortsdurchfahrt', 'tran_2.jpg', $event)">
				<br>Transilvania, Siebenbürgen: Ortsdurchfahrt
      </div>
      <div class="foto">
				<img src="../assets/fotos/tran_3kl.jpg" width="125" border="0" height="110" alt="Transilvania, Siebenbürgen: Orlat"
        @click="callImageClick('Transilvania, Siebenbürgen: Orlat', 'tran_3.jpg', $event)">
				<br>Transilvania, Siebenbürgen: Orlat
      </div>
      <div class="foto">
				<img src="../assets/fotos/tran_4kl.jpg" width="125" border="0" height="110" alt="Transilvania, Siebenbürgen: Storchennester"
        @click="callImageClick('Transilvania, Siebenbürgen: Storchennester', 'tran_4.jpg', $event)">
        <br>Transilvania, Siebenbürgen: Storchennester
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>